import useLayout from 'layout/useLayout'
import { RenderDialog } from 'myenergy/mainContent/components/RenderDialog'
import { letterIsAvailable, showCoverMessageDialog } from 'myenergy/prepareProposalData'
import { useCallback, useMemo, useState } from 'react'

const defaultState = {
  activeDialog: null,
  dialogData: null,
  dialogIsFullWidth: false,
}

const useRenderDialog = ({ proposalData }) => {
  const [state, setState] = useState({ ...defaultState })
  const layout = useLayout()

  const showDialog = useCallback((dialogName, dialogData = null, isFullWidth = false) => {
    // DialogHelper.afterOpen()
    setState({ activeDialog: dialogName, dialogData: dialogData, dialogIsFullWidth: isFullWidth })
  }, [])

  const closeDialog = useCallback(() => {
    // DialogHelper.beforeClose()
    setState({ ...defaultState })
  }, [])

  const dialog = useMemo(
    () =>
      state.activeDialog ? (
        <RenderDialog
          proposalData={proposalData}
          activeDialog={state.activeDialog}
          closeDialog={closeDialog}
          dialogData={state.dialogData}
          dialogIsFullWidth={false}
          layout={layout}
          content={
            letterIsAvailable(proposalData) ? proposalData?.selectedProject?.proposal_data?.proposal_message : null
          }
          showLetter={showCoverMessageDialog(proposalData)}
        />
      ) : null,
    [proposalData, state, layout]
  )

  return useMemo(() => {
    return {
      state,
      showDialog,
      closeDialog,
      dialog,
    }
  }, [state, showDialog, closeDialog, dialog])
}

export default useRenderDialog
